import { GET_SYNCHRONIZATION_ERRORS_FAILED, GET_SYNCHRONIZATION_ERRORS_SUCCESS, GET_SYNCHRONIZATION_ERRORS_WATCHER } from "./contants";


export function getSynchronizationErrorsWatcher (payload) {
    return {
        payload,
        type: GET_SYNCHRONIZATION_ERRORS_WATCHER,
    }
}

export function getSynchronizationErrorsSuccess (payload) {
    return {
        payload,
        type: GET_SYNCHRONIZATION_ERRORS_SUCCESS,
    }
}

export function getSynchronizationErrorsFailed (payload) {
    return {
        payload,
        type: GET_SYNCHRONIZATION_ERRORS_FAILED,
    }
}